export enum QuickscanPublish {
    PUBLISH = 'publish'
}
